import React from 'react';
import { useDrop } from 'react-dnd';
import useStyles from 'isomorphic-style-loader/useStyles';

import { DnDOptionItemV2 } from './DnDOptionItemV2';
import { DND_ACCEPT_TYPES } from '../constants';
import { DnDAnswerOption } from '../interface';

import s from './DnDOptionsV2.scss';

export interface IDnDOptionsV2Props {
    options: DnDAnswerOption[];
    onOptionSelect: (item: DnDAnswerOption) => void;
    onOptionDropBack: (dropItem: {
        value: DnDAnswerOption;
        index: number;
    }) => void;
}

export function DnDOptionsV2({
    options,
    onOptionSelect,
    onOptionDropBack,
}: IDnDOptionsV2Props) {
    useStyles(s);
    const [{ isOver }, drop] = useDrop({
        accept: [DND_ACCEPT_TYPES.DROP_OPTION],
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
        drop: onOptionDropBack,
    });

    return (
        <div
            ref={drop}
            className={`sl-dnd-options-v2${isOver ? ' is-over' : ''}`}
        >
            {options.map((option) => {
                return (
                    <DnDOptionItemV2
                        key={option.id}
                        option={{ ...option }}
                        onOptionSelect={onOptionSelect}
                    />
                );
            })}
        </div>
    );
}
